// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon-module--icon--Gpyvw"};